import { createWebClient } from "@cd2/skeem-client"
import { env } from "../env"

declare global {
  interface Window {
    skeem: ReturnType<typeof createWebClient>
  }
}

export const skeemWebClient = createWebClient({ url: env.SKEEM_URL })
;(window as any).skeem = skeemWebClient
